"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Logo = exports.TextWithSeparatorOptions = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _rtl = require("@kiwicom/orbit-components/lib/utils/rtl");
var _mediaQuery = _interopRequireDefault(require("@kiwicom/orbit-components/lib/utils/mediaQuery"));
var _Theme = require("../../records/Theme");
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _jsxRuntime = require("react/jsx-runtime");
var _TextWithSeparator;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const navbarLogoAltText = (0, _reactIntl.defineMessage)({
  id: "navbar.logo.alt_text"
});
const TextWithSeparator = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "Logo__TextWithSeparator",
  componentId: "sc-1uwlkrd-0"
})(["color:", ";position:relative;font-size:10px;font-family:", ";font-weight:", ";line-height:initial;padding-", ":8px;&:before{content:\"\";top:0;bottom:0;", ":0;margin:auto;position:absolute;width:1px;background:", ";height:24px;}", ";"], ({
  theme
}) => theme.orbit.paletteInkDark, ({
  theme
}) => theme.orbit.fontFamily, ({
  theme
}) => theme.orbit.fontWeightNormal, /* sc-custom "left" */_rtl.left, /* sc-custom "left" */_rtl.left, ({
  theme
}) => theme.orbit.paletteCloudDark, _mediaQuery.default.largeMobile((0, _styledComponents.css)(["font-size:", ";padding-", ":12px;font-weight:", ";"], ({
  theme
}) => theme.orbit.fontSizeTextSmall, /* sc-custom "left" */_rtl.left, ({
  theme
}) => theme.orbit.fontWeightMedium)));
TextWithSeparator.defaultProps = {
  theme: _Theme.themeDefault
};
const KiwiLogoStyled = /*#__PURE__*/_styledComponents.default.img.withConfig({
  displayName: "Logo__KiwiLogoStyled",
  componentId: "sc-1uwlkrd-1"
})(["display:none;", ";"], _mediaQuery.default.mediumMobile((0, _styledComponents.css)(["display:block;"])));
KiwiLogoStyled.defaultProps = {
  theme: _Theme.themeDefault
};
const KiwiLogoStyledMobile = /*#__PURE__*/_styledComponents.default.img.withConfig({
  displayName: "Logo__KiwiLogoStyledMobile",
  componentId: "sc-1uwlkrd-2"
})(["display:block;", ";"], _mediaQuery.default.mediumMobile((0, _styledComponents.css)(["display:none;"])));
KiwiLogoStyledMobile.defaultProps = {
  theme: _Theme.themeDefault
};
const LogoLinkStyled = /*#__PURE__*/_styledComponents.default.a.withConfig({
  displayName: "Logo__LogoLinkStyled",
  componentId: "sc-1uwlkrd-3"
})(["display:flex;"]);
const LogoStyled = /*#__PURE__*/_styledComponents.default.img.withConfig({
  displayName: "Logo__LogoStyled",
  componentId: "sc-1uwlkrd-4"
})(["display:none;", ";"], _mediaQuery.default.largeMobile((0, _styledComponents.css)(["display:block;max-height:35px;max-width:140px;align-self:center;"])));
LogoStyled.defaultProps = {
  theme: _Theme.themeDefault
};
const LogoStyledMobile = /*#__PURE__*/_styledComponents.default.img.withConfig({
  displayName: "Logo__LogoStyledMobile",
  componentId: "sc-1uwlkrd-5"
})(["max-height:40px;max-width:40px;align-self:center;", ";"], _mediaQuery.default.largeMobile((0, _styledComponents.css)(["display:none;"])));
LogoStyledMobile.defaultProps = {
  theme: _Theme.themeDefault
};
const Link = /*#__PURE__*/_styledComponents.default.a.withConfig({
  displayName: "Logo__Link",
  componentId: "sc-1uwlkrd-6"
})(["display:flex;outline:none;:focus{::after{content:\"\";display:block;position:absolute;top:-3px;bottom:-3px;left:0;right:0;border-radius:", ";border:2px solid ", ";}}position:relative;", ""], ({
  theme
}) => theme.orbit.borderRadiusLarge, ({
  theme
}) => theme.orbit.paletteProductNormal, _mediaQuery.default.mediumMobile((0, _styledComponents.css)([":focus{::after{left:-5px;right:-5px;}}"])));
Link.defaultProps = {
  theme: _Theme.themeDefault
};
const imagesBaseUrl = "https://images.kiwi.com";
let TextWithSeparatorOptions;
exports.TextWithSeparatorOptions = TextWithSeparatorOptions;
(function (TextWithSeparatorOptions) {
  TextWithSeparatorOptions["POWERED_BY_KIWI"] = "poweredByKiwi";
})(TextWithSeparatorOptions || (exports.TextWithSeparatorOptions = TextWithSeparatorOptions = {}));
const LogoComponent = ({
  id,
  redirectUrl,
  url,
  title,
  onClick
}) => {
  const intl = (0, _reactIntl.useIntl)();
  if (id === "kiwicom") {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Link, {
      "data-test": "Logo",
      href: url || redirectUrl,
      onClick: onClick,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(KiwiLogoStyled, {
        title: intl.formatMessage(navbarLogoAltText, {
          brandName: title
        }),
        alt: intl.formatMessage(navbarLogoAltText, {
          brandName: title
        }),
        src: `${imagesBaseUrl}/common/kiwicom-logo.svg`,
        width: 80,
        height: 50
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(KiwiLogoStyledMobile, {
        title: intl.formatMessage(navbarLogoAltText, {
          brandName: title
        }),
        alt: intl.formatMessage(navbarLogoAltText, {
          brandName: title
        }),
        src: `${imagesBaseUrl}/common/kiwicom-logo-mobile.svg`,
        width: 80,
        height: 50
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(LogoLinkStyled, {
    "data-test": "Logo",
    href: url || redirectUrl,
    onClick: onClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(LogoStyled, {
      title: intl.formatMessage(navbarLogoAltText, {
        brandName: title
      }),
      alt: intl.formatMessage(navbarLogoAltText, {
        brandName: title
      }),
      srcSet: `${imagesBaseUrl}/whitelabels/0x80/${id}.png?v=1 2x`,
      src: `${imagesBaseUrl}/whitelabels/0x40/${id}.png?v=1`
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(LogoStyledMobile, {
      title: intl.formatMessage(navbarLogoAltText, {
        brandName: title
      }),
      alt: intl.formatMessage(navbarLogoAltText, {
        brandName: title
      }),
      srcSet: `${imagesBaseUrl}/whitelabels/0x80/${id}-mobile.png?v=1 2x`,
      src: `${imagesBaseUrl}/whitelabels/0x40/${id}-mobile.png?v=1`
    })]
  });
};
const LogoText = ({
  textWithSeparator
}) => {
  switch (textWithSeparator) {
    case TextWithSeparatorOptions.POWERED_BY_KIWI:
      return _TextWithSeparator || (_TextWithSeparator = /*#__PURE__*/(0, _jsxRuntime.jsxs)(TextWithSeparator, {
        children: ["Powered by", /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), "Kiwi.com"]
      }));
    default:
      return null;
  }
};
const Logo = ({
  id,
  redirectUrl,
  title,
  url,
  textWithSeparator,
  onClick
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
  inline: true,
  direction: "row",
  align: "center",
  grow: false,
  spacing: "XSmall",
  largeMobile: {
    spacing: "small"
  },
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(LogoComponent, {
    title: title,
    id: id,
    url: url,
    redirectUrl: redirectUrl,
    onClick: onClick
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(LogoText, {
    textWithSeparator: textWithSeparator
  })]
});
exports.Logo = Logo;
var _default = Logo;
exports.default = _default;